export default "__VITE_ASSET__CO3NcU$z__"